import React from "react";
import { Box, Flex } from "rebass/styled-components";

import { layout } from "../../../constants/constants";
import useFeatureToggle from "../../hooks/use-feature-toggle/useFeatureToggle";
import { FeatureToggle, SingleColumnContent, TwoColumnContent, IconPack, AccordionBlock } from "../../models/app-data-model";
import SingleColumnBlock from "../single-column-block/single-column-block";
import TwoColumnBlock from "../two-column-block/two-column-block";
import AccordionItem from "./accordion-item/accordion-item";
import "./accordion.scss";

export type ContentAccordionProps = {
  contentAccordion: AccordionBlock;
  featureToggles: FeatureToggle[];
  iconPack: IconPack[];
  corewellStyleOverrides?: boolean;
  dynamicContainerOverride?: boolean;
  insideOfTab?: boolean;
};

const ContentAccordion: React.FC<ContentAccordionProps> = ({
  contentAccordion,
  featureToggles,
  iconPack,
  corewellStyleOverrides,
  dynamicContainerOverride,
  insideOfTab
}: ContentAccordionProps) => {
  const showContentAccordion: boolean = useFeatureToggle("content-accordion", featureToggles);

  if (!showContentAccordion) {
    return null;
  }

  return (
    <Flex className={`content-accordion ${insideOfTab && "no-bottom-padding"}`}>
      <Box
        className={`accordion content-container ${!insideOfTab && "add-panel"}`}
        width={dynamicContainerOverride || insideOfTab ? 1 : layout.pageWidth}
        px={dynamicContainerOverride || insideOfTab ? [] : layout.pagePaddingX}
        marginX={dynamicContainerOverride ? "" : "auto"}
      >
        {contentAccordion?.accordion_item.map((item, index) => {
          return (
            <AccordionItem
              heading={item?.accordion_details?.header}
              linkId={item?.accordion_details?.link_id}
              headingClass={"content-accordion-item"}
              open={item?.accordion_details?.default_open}
              key={`accordion-item-${contentAccordion?.uid}-${index}`}
              iconPack={iconPack}
              defaultIcon={false}
              corewellStyleOverrides={corewellStyleOverrides}
              insideOfTab={insideOfTab}
            >
              {item?.accordion_details?.accordion_content.map((columnBlock, i) => {
                if (columnBlock.single_column_block) {
                  return (
                    <SingleColumnBlock
                      iconPack={iconPack}
                      key={"one-col-" + i}
                      column={columnBlock.single_column_block as SingleColumnContent}
                      featureToggles={featureToggles}
                    />
                  );
                } else if (columnBlock.two_column_content_block) {
                  return (
                    <TwoColumnBlock
                      key={"two-col-" + i}
                      content={columnBlock.two_column_content_block as TwoColumnContent}
                      featureToggles={featureToggles}
                      iconPack={iconPack}
                    />
                  );
                }
              })}
            </AccordionItem>
          );
        })}
      </Box>
    </Flex>
  );
};

export default ContentAccordion;
